export function getRatingReportT() {
    return new Promise((resolve, reject) => {
        fetch("https://www.jpadel-cms.com/api/users/getRatingReport", {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "authorization": window.localStorage.getItem('token'),
                },
            })
            .then((res) => {
                resolve(res.json());
            })
            .catch((err) => reject(err));
    });
}


export function getRatingReportWDate(data) {
    return new Promise((resolve, reject) => {
        fetch("https://www.jpadel-cms.com/api/users/getRatingReportWDate", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "authorization": window.localStorage.getItem('token'),
                },
             body: JSON.stringify(data),
            })
            .then((res) => {
                resolve(res.json());
            })
            .catch((err) => reject(err));
    });
}

